
import { createContext } from "react"

const yearContext = createContext();

export default yearContext;